var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMembers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.28 17V19H2.28V17C2.28 17 2.28 13 9.28 13C16.28 13 16.28 17 16.28 17ZM12.78 7.50001C12.78 6.80777 12.5747 6.13108 12.1901 5.55551C11.8056 4.97994 11.2589 4.53134 10.6194 4.26643C9.97985 4.00152 9.27612 3.93221 8.59718 4.06726C7.91825 4.20231 7.29461 4.53565 6.80513 5.02513C6.31564 5.51462 5.9823 6.13826 5.84725 6.81719C5.7122 7.49612 5.78151 8.19986 6.04642 8.8394C6.31133 9.47894 6.75993 10.0256 7.3355 10.4102C7.91108 10.7947 8.58776 11 9.28 11C10.2083 11 11.0985 10.6313 11.7549 9.97488C12.4112 9.3185 12.78 8.42826 12.78 7.50001ZM16.22 13C16.8347 13.4758 17.3378 14.0804 17.6937 14.7715C18.0496 15.4626 18.2497 16.2233 18.28 17V19H22.28V17C22.28 17 22.28 13.37 16.22 13ZM15.28 4.00001C14.5917 3.99617 13.9185 4.20196 13.35 4.59001C13.9574 5.43874 14.2841 6.45629 14.2841 7.50001C14.2841 8.54372 13.9574 9.56127 13.35 10.41C13.9185 10.7981 14.5917 11.0038 15.28 11C16.2083 11 17.0985 10.6313 17.7549 9.97488C18.4113 9.3185 18.78 8.42826 18.78 7.50001C18.78 6.57175 18.4113 5.68151 17.7549 5.02513C17.0985 4.36876 16.2083 4.00001 15.28 4.00001Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMembers);
export default __webpack_public_path__ + "static/media/members.58812b31d6afe81223a4cff3cb1fcfef.svg";
export { ForwardRef as ReactComponent };